import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let licenseKindQuery = new Parse.Query('LicenseKind');
	licenseKindQuery.notEqualTo("deleted", true)
		.find()
		.then((results) => {
			store.dispatch('licenseKind/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			console.log(error);
		});
		licenseKindQuery.subscribe().then((subscription) => {
		localSubscription = subscription;

		subscription.on('create', (object) => {
			store.dispatch('licenseKind/insert', object)
		});
		subscription.on('update', (object) => {
			store.dispatch('licenseKind/replace', object)
		});
		subscription.on('enter', (object) => {
			store.dispatch('licenseKind/insert', object)
		});
		subscription.on('leave', (object) => {
			store.dispatch('licenseKind/delete', object)
		});
		subscription.on('delete', (object) => {
			store.dispatch('licenseKind/delete', object)
		});
		subscription.on('close', () => {
		});
		subscription.on('error', error => {
			console.log('LicenseKind subscription error', error);
		})
	})
}

export default function createLicenseKindSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
